import { deserialize, serializable } from 'serializr';
import { PageObject } from '@testsigmainc/models';
import { Base } from '@models/base.model';

enum SalesforceLoginMethod {
  OAUTH = 'OAUTH',
  USERNAME_PASSWORD = 'USERNAME_PASSWORD',
}

enum SalesforceConnectionType {
  METADATA = 'METADATA',
  USER = 'USER',
}

enum SalesforceConnectionEdition {
  PRODUCTION_OR_DEVELOPER = 'PRODUCTION_OR_DEVELOPER',
  SANDBOX = 'SANDBOX',
  SCRATCH_ORG = 'SCRATCH_ORG',
}
const getSalesforceLoginMethodI18nKey = (type) =>
  `salesforce.login.method.${type}`;
const getSalesforceEditionI18nKey = (type) =>
  `salesforce.connection.edition.${type}`;

class SalesforceConnection extends Base implements PageObject {
  @serializable
  public name: string;

  @serializable
  public applicationVersionId: number;

  @serializable
  public isSandbox: boolean;

  @serializable
  public isScratchOrg: boolean;

  @serializable
  public instanceUrl: string;

  @serializable
  public expirationDate: Date;

  @serializable
  public username: string;

  @serializable
  public password: string;

  @serializable
  public clientId: string;

  @serializable
  public clientSecret: string;

  @serializable
  public securityToken: string;

  @serializable
  public loginMethod: SalesforceLoginMethod;

  @serializable
  public connectionType: SalesforceConnectionType;

  @serializable
  public callbackUrl: string;

  @serializable
  public accessToken: string;

  @serializable
  public refreshToken: string;

  @serializable
  public authCode: string;

  @serializable
  public environmentName: string;

  public salesforceConnectionEdition: SalesforceConnectionEdition;

  @serializable
  public performValidation: boolean = true;

  @serializable
  public isAdmin: boolean = false;

  @serializable
  public applicationId: number;

  @serializable
  public isDuplicate: boolean;

  @serializable
  public lastSync: Date;

  @serializable
  public createdDate: Date;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(SalesforceConnection, input));
  }
}

export {
  SalesforceConnection,
  SalesforceLoginMethod,
  SalesforceConnectionType,
  SalesforceConnectionEdition,
  getSalesforceLoginMethodI18nKey,
  getSalesforceEditionI18nKey,
};
